import { jsxs, jsx } from 'react/jsx-runtime';
import { IconButton } from '../../icon-button/icon-button.component.js';
import { StyledHeader, Title } from '../modal.style.js';

const ModalHeaderCentered = props => {
    const { onBack, title, onClose } = props;
    return (jsxs(StyledHeader, { children: [onBack && (jsx(IconButton, { "aria-label": "Back button", onClick: onBack, icon: "ChevronLeft", margin: { right: '24px' } }, void 0)), jsx(Title, Object.assign({ tag: "h2", textStyle: "heading700", textAlign: "center" }, { children: title }), void 0), onClose && (jsx(IconButton, { "aria-label": "Close button", onClick: onClose, icon: "UIClose", margin: { left: '24px' } }, void 0))] }, void 0));
};

export { ModalHeaderCentered };
